<section class="c-section--static" *ngIf="!vm.isAuthenticated">

    <div class="c-section__header c-text--center">
        <div class="o-container c-container">
            <div class="o-container">
                <div class="o-grid">
                    <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v">
                        <a id="headerLogoSiffi" href="javascript:void(0);" (click)="vm.navigateToRoot($event)" style="z-index: 10000; cursor: pointer; width: 124px; height: 33px; margin-left: 39px;" class="c-header__logo c-logo c-logo--siffi-green c-logo--siffi-green@up-to-md"></a>
                    </div>
                </div>
            </div>
            <!-- Language menu -->
            <nav class="c-nav c-nav--tab-bar" style="z-index: 9999; top: 10px; right: 30px;">
                <div class="o-container">
                    <div class="c-nav__menu">
                        <ul class="c-nav__list">
                            <li class="c-nav__item">
                                <siffi-language-picker [currentLocale]="vm.locale" (localeSelected)="vm.setLocale($event)"></siffi-language-picker>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    </div>

    <div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--flex o-grid__cell--center@md-and-up u-no-p o-grid__cell--o2@up-to-md">
        <main class="o-container c-container">
            <div class="o-grid o-grid--center-h">
                <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up o-grid__cell--w-40@xl-and-up">
                    <div class="c-content">
                        <h1 class="c-text--bold c-text--center" *ngIf="!vm.isScreeningCompletion">{{ "VerifyEmail.VerifyEmail_Title" | translateUnauthenticated }}</h1>
						<div *ngIf="vm.isScreeningCompletion && !vm.isSuccess && !vm.showError" style="margin-top: 15px">
							<p class="c-text c-text--center u-osb-lg">{{ "Screening.Pilot.Verify.Lead" | translateUnauthenticated }}</p>
							<div class="c-form__group">
								<label class="c-form__label">{{ 'Register.Password' | translateUnauthenticated }}</label>
                                <input type="password" class="c-form__input c-form__input--sm" [(ngModel)]="vm.password">
                            </div>
                            <div class="c-form__group">
                                <label class="c-form__label">{{ 'Register.Repeat_Password' | translateUnauthenticated }}</label>
                                <input type="password" class="c-form__input c-form__input--sm" [(ngModel)]="vm.passwordConfirm">
                            </div>
                            <p class="c-text c-text--s6 c-text--center u-osb-lg">{{ "Reset_Password.Password_Requirements" | translateUnauthenticated }}</p>
                            <p class="c-text c-text--s3 c-text--center u-osb-lg" *ngIf="vm.passwordError">{{ vm.passwordError | translateUnauthenticated }}</p>
                            <div class="o-grid">
                                <div class="o-grid__cell o-grid__cell--center-h">
                                    <button type="button" class="c-button c-button--s12 c-form__center-button" (click)="vm.completeScreeningRegistration()">{{ "Screening.Pilot.Verify.Submit" | translateUnauthenticated }}</button>
								</div>
							</div>
						</div>
						<div class="o-grid" *ngIf="vm.isScreeningCompletion && vm.showError" style="margin-top: 15px">
							<div class="o-grid__cell o-grid__cell--center-h">
								<p class="c-text c-text--center u-osb-lg">{{ "Screening.Pilot.Verify.Link_Error" | translateUnauthenticated }}</p>
							</div>
						</div>
						<div class="o-grid" *ngIf="vm.isScreeningCompletion && vm.isSuccess" style="margin-top: 15px">
							<div class="o-grid__cell o-grid__cell--center-h">
								<h1 class="c-text--bold c-text--center" id="registrationSuccessMessage">{{ "Register.Registration_Successful" | translateUnauthenticated }}</h1>
                            </div>
                        </div>
                        <div class="o-grid" *ngIf="vm.isScreeningCompletion && vm.isSuccess" style="margin-top: 15px">
                            <div class="o-grid__cell o-grid__cell--center-h">
                                <p class="c-text c-text--center u-osb-lg">{{ "VerifyEmail.Success" | translateUnauthenticated }}</p>
                            </div>
                        </div>
                        <div class="o-grid" *ngIf="vm.isScreeningCompletion && vm.isSuccess">
                            <div class="o-grid__cell o-grid__cell--center-h">
                                <a id="go-back-link-screening" class="c-button--link c-button--s12 c-text--underline" [routerLink]="['/login']" [queryParams]="vm.localeParams">{{ "Register.Go_To_Login" | translateUnauthenticated }}</a>
                            </div>
                        </div>
                        <div class="o-grid" *ngIf="!vm.isScreeningCompletion && vm.isSuccess && !vm.isSuccessIndividualUser" style="margin-top: 15px">
                            <div class="o-grid__cell o-grid__cell--center-h">
                                <p class="c-text c-text--center u-osb-lg" >{{ "Reset_Password.Cant_Use_Link_Multiple_Times"  | translateUnauthenticated }}</p>
                            </div>
                        </div>
                        <div class="o-grid" *ngIf="!vm.isScreeningCompletion && vm.isSuccess && vm.isSuccessIndividualUser" style="margin-top: 15px">
                            <div class="o-grid__cell o-grid__cell--center-h">
                                <p class="c-text c-text--center u-osb-lg" >{{ "VerifyEmail.Success"  | translateUnauthenticated }}</p>
                            </div>
                        </div>
                        <div class="o-grid" *ngIf="!vm.isScreeningCompletion && vm.isSuccess">
                            <div class="o-grid__cell o-grid__cell--center-h">
                                <a id="go-back-link" class="c-button--link c-button--s12 c-text--underline" [routerLink]="['/login']" [queryParams]="vm.localeParams">{{ "Login.Login_Title" | translateUnauthenticated }}</a>
                            </div>
                        </div>
                        <div class="o-grid" *ngIf="!vm.isScreeningCompletion && vm.isSuccess" style="margin-top: 15px">
                            <div class="o-grid__cell o-grid__cell--center-h">
                                <a id="reset-password-link" class="c-button--link c-button--s12 c-text--underline" [routerLink]="['/reset-password']" [queryParams]="vm.localeParams">
                                    {{ "Reset_Password.Change_Password" | translateUnauthenticated }}
                                </a>
                            </div>
                        </div>
                        <div class="o-grid" *ngIf="!vm.isScreeningCompletion && !vm.isSuccess" style="margin-top: 15px">
                            <div class="o-grid__cell o-grid__cell--center-h">
                                <p class="c-text c-text--center u-osb-lg" >{{ "VerifyEmail.Failure"  | translateUnauthenticated }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</section>
